var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._g(_vm._b({style:(Object.assign({}, {minWidth: '97px',
    height: '50px',
    background: ((_vm.submit ? '#000B8D' : 'white') + "  0% 0% no-repeat padding-box"),
    border: ("3px solid " + (_vm.submit ? '#000B8D' : '#707070')),
    borderRadius: '25px',
    color: _vm.submit ? 'white' : 'black'},
    _vm.$attrs.style))},'v-btn',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }